import { AppointmentData, InvoiceReduced } from '../../../models';

export interface InvoiceCreatedSyncDeps {
    getLatestData: () => AppointmentData;
    onChange: (appointment: AppointmentData) => void;
    setInvoiceModal: (value: boolean) => void;
    getAppointment: (id: string) => Promise<AppointmentData>;
    onSyncError?: (error: unknown) => void;
}

export interface ReceiptEmittedSyncDeps {
    getLatestData: () => AppointmentData;
    onChange: (appointment: AppointmentData) => void;
    getAppointment: (id: string) => Promise<AppointmentData>;
    onSyncError?: (error: unknown) => void;
}

export const applyOptimisticInvoiceToAppointment = (
    appointment: AppointmentData,
    invoice: InvoiceReduced,
): AppointmentData => ({
    ...appointment,
    invoices: [...(appointment.invoices ?? []), invoice],
} as AppointmentData);

export const mergeFinancialSnapshot = (
    current: AppointmentData,
    updated: AppointmentData,
): AppointmentData => ({
    ...current,
    invoices: updated.invoices ?? current.invoices,
    payments: updated.payments ?? current.payments,
});

export const handleReceiptEmittedWithSync = (deps: ReceiptEmittedSyncDeps): void => {
    const latestData = deps.getLatestData();
    if (!latestData.id) return;

    deps.getAppointment(latestData.id)
        .then((updatedAppointment) => {
            const currentData = deps.getLatestData();
            deps.onChange(mergeFinancialSnapshot(currentData, updatedAppointment));
        })
        .catch((error) => {
            deps.onSyncError?.(error);
        });
};

export const handleInvoiceCreatedWithSync = (
    invoice: InvoiceReduced,
    deps: InvoiceCreatedSyncDeps,
): void => {
    const latestData = deps.getLatestData();
    deps.onChange(applyOptimisticInvoiceToAppointment(latestData, invoice));
    deps.setInvoiceModal(false);

    if (!latestData.id) return;

    deps.getAppointment(latestData.id)
        .then((updatedAppointment) => {
            const currentData = deps.getLatestData();
            deps.onChange(mergeFinancialSnapshot(currentData, updatedAppointment));
        })
        .catch((error) => {
            deps.onSyncError?.(error);
        });
};
